import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ProjectSettings } from './project.settings';
import { parseBase64StorageJSON } from './functions';
import { CmxAuth } from './models/cemex-auth';
declare var global: any;

@Injectable()
export class HttpCemex {
  private _validSettings = false;

  constructor(
    private http: HttpClient,
    private projectSettings: ProjectSettings,
  ) {
    this._validSettings = this.validateProjectSettings();
  }

  public generateEndpoint(apiEndpoint: string): string {
    return this.projectSettings.generateEndpoint(apiEndpoint);
  }

  get clientId(): string {
    return this.projectSettings.clientId;
  }

  get appCode(): string {
    return this.projectSettings.appCode;
  }

  public request(url: string, options?: any) {
    const loptions = this.createAuthorizationHeader(options);
    return this.http.request('GET', url, loptions);
  }

  public get(url: string, options?: any, overrideHeader?: boolean) {
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.get(url, loptions);
  }

  public post(url: string, body: any, options?: any, overrideHeader?: boolean): any {
    if (!this._validSettings) {
      const message = 'Set missing environment variables of API_HOST, API_ORG, API_ENV, APP_CODE, CLIENT_ID';
      return throwError(new Error(message));
    }
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.post(url, body, loptions);
  }

  public put(url: string, body: any, options?: any, overrideHeader?: boolean) {
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.put(url, body, loptions);
  }

  public patch(url: string, body: any, options?: any, overrideHeader?: boolean) {
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.patch(url, body, loptions);
  }

  public delete(url: string, options?: any, overrideHeader?: boolean) {
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.delete(url, loptions);
  }

  public head(url: string, options: any, overrideHeader?: boolean) {
    const loptions = this.createAuthorizationHeader(options, overrideHeader);
    return this.http.head(url, loptions);
  }

  public isRunningOnBrowser(): boolean {
    return (global as any) !== null && (global as any) !== undefined;
  }

  public encrypt(str: string) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  public decrypt(str: string) {
    return str ? decodeURIComponent(escape(window.atob(str))) : str;
  }

  public setProjectSettingsNewKeys(newKeys: any): void {
    this.projectSettings.setAppKeys(newKeys);
  }

  protected createAuthorizationHeader(options: any, overrideHeader?: boolean): any {
    const containsHeader = options && options.headers;
    const result = options ? { ...options } : {};
    let headers = new HttpHeaders();

    headers = headers.set('Accept', 'application/json');
    headers = headers.set('X-IBM-Client-Id', this.projectSettings.clientId);
    headers = headers.set('App-Code', this.projectSettings.appCode);

    const language = this.isRunningOnBrowser() ? (window as any).localStorage.getItem('language') || 'en' : 'en';
    headers = headers.set('Accept-Language', language);

    const data = this.getDataSession();
    if (data && data.oauth2 && data.oauth2.access_token) {
      headers = headers.set('Authorization', 'Bearer ' + data.oauth2.access_token);
    }
    if (this.isRunningOnBrowser() && data && data.jwt) {
      headers = headers.set('jwt', data.jwt);
    }

    if (containsHeader && !overrideHeader) {
      const existingKeys = options.headers.keys();
      existingKeys.forEach((key: string) => {
        headers = headers.set(key, options.headers.get(key));
      });
    } else if (containsHeader && overrideHeader) {
      headers = options.headers;
    }

    result.headers = headers;
    return result;
  }

  private validateProjectSettings(): boolean {
    const settings = this.projectSettings;
    return (
      settings.apiBasePath !== undefined &&
      settings.apiEnv !== undefined &&
      settings.apiOrg !== undefined &&
      settings.appCode !== undefined &&
      settings.clientId !== undefined
    );
  }

  private getDataSession() {
    return parseBase64StorageJSON<CmxAuth>('session', '_cmx_');
  }
}
